export const SEQ_CONSULT_NEXT_BUTTON_ID = 'seq-next-button';

export const CONSULT_NAME_PATTERN = '^[a-zA-Z가-힣\\s]{1,20}$';

export const SITE_BUILDING_TYPE = {
  gtmKey: 'type',
  title: `인테리어가 필요한 공간은 어디인가요?`,
  autoNext: true,
  data: [
    { name: '아파트', value: 'HT_001' },
    { name: '빌라', value: 'HT_002' },
    { name: '단독주택', value: 'HT_004' },
    { name: '오피스텔', value: 'HT_005' },
  ],
};

export const SITE_HOUSE_NMPG = {
  gtmKey: 'py',
  title: `인테리어 공간의 평수를 선택해주세요.`,
  autoNext: true,
  data: [
    { name: '10~20평대', value: 'TEN' },
    { name: '30평대', value: 'THIRTY' },
    { name: '40평대', value: 'FORTY' },
    { name: '50평대 이상', value: 'FIFTY' },
  ],
};

export const SPACE_STATUS = {
  gtmKey: 'status',
  title: '인테리어 할 집은 어떤 상태인가요?',
  autoNext: true,
  data: [
    { name: '짐보관 후 살면서 공사예정', value: 'ME' },
    { name: '현재 공실', value: 'EMPTY' },
    { name: '시공 시 공실 예정', value: 'TOBEEMPTY' },
    { name: '신축입주', value: 'MOVEIN' },
    { name: '기타 (부동산 미계약 상태)', value: 'ETC' },
  ],
};

export const CONSULT_PURPOSE = {
  gtmKey: 'purpose',
  title: '인테리어를 고려하시게 된 주요 이유를 선택해주세요.',
  autoNext: true,
  data: [
    { name: '집을 구매하여 리모델링 계획 중', value: 'CPT01' },
    { name: '사는 집을 새롭게 바꾸기 위해', value: 'CPT02' },
    { name: '매매나 임대를 위한 리모델링', value: 'CPT03' },
    { name: '기타', value: 'CPT04' },
  ],
};

export const SPACE_SCOPES = {
  gtmKey: 'range',
  title: '인테리어가 필요한 공간을 모두 골라주세요.',
  autoNext: false,
  data: [
    { name: '키친', value: 'KITCHEN' },
    { name: '바스', value: 'BATH' },
    { name: '수납', value: 'STORAGE' },
    { name: '마루', value: 'FLOOR' },
    { name: '중문', value: 'CENTRAL_DOOR' },
    { name: '도어', value: 'DOOR' },
    { name: '창호', value: 'WINDOW' },
    { name: '필름', value: 'FILM' },
    { name: '벽지', value: 'WALLPAPER' },
    { name: '조명', value: 'LIGHT' },
    { name: '타일', value: 'TILE' },
    { name: '기타 입력', value: 'ETC' },
  ],
};

export const BUDGET = {
  gtmKey: 'budget',
  title: '인테리어 예산은 총 얼마를 생각하시나요?',
  autoNext: true,
  data: [
    {
      name: '5백만원 이하',
      value: 500,
    },
    {
      name: '1천만원 이하',
      value: 1000,
    },
    {
      name: '2천만원 이하',
      value: 2000,
    },
    {
      name: '3천만원 이하',
      value: 3000,
    },
    {
      name: '4천만원 이하',
      value: 4000,
    },
    {
      name: '5천만원 이하',
      value: 5000,
    },
    {
      name: '6천만원 이하',
      value: 6000,
    },
    {
      name: '7천만원 이하',
      value: 7000,
    },
    {
      name: '1억원 이하',
      value: 10000,
    },
    {
      name: '아직 미정이에요',
      value: 0,
    },
  ],
};

export const DESIRED_DAY = {
  gtmKey: 'date',
  title: '인테리어가 언제 시작되길 희망하시나요?',
  autoNext: true,
  data: [
    { name: '1개월 이내', value: 'BEFORE_1_MONTH' },
    { name: '2개월 이내', value: 'BEFORE_2_MONTH' },
    { name: '3개월 이내', value: 'BEFORE_3_MONTH' },
    { name: '3개월 이후', value: 'AFTER_3_MONTH' },
    { name: '6개월 이후', value: 'AFTER_6_MONTH' },
  ],
};

export const CONSULT_SCHEDULE = {
  gtmKey: 'call',
  title: '원하시는 상담 일정을 알려주세요.',
  autoNext: true,
  data: [
    { name: '가능한 빨리', value: 'ASAP' },
    { name: '10일 이내', value: 'BEFORE_10_DAY' },
    { name: '한달 이내', value: 'BEFORE_1_MONTH' },
    { name: '한달 이후', value: 'AFTER_1_MONTH' },
  ],
};

export const AGE = {
  gtmKey: 'age',
  title: '고객님의 연령대를 알려주세요.',
  autoNext: true,
  data: [
    { name: '20~30대', value: '30' },
    { name: '40대', value: '40' },
    { name: '50대', value: '50' },
    { name: '60대 이상', value: '60' },
  ],
};

export const CONSULT_EXPERIENCE = {
  gtmKey: 'count',
  title: '인테리어 상담을 받아보신 적 있나요?',
  autoNext: true,
  data: [
    { name: '없음', value: 'EXP01' },
    { name: '1~2회', value: 'EXP02' },
    { name: '3회 이상', value: 'EXP03' },
  ],
};

export const OPINION_REFLECT = {
  gtmKey: 'feedback',
  title: '고객님의 의견이  어느 정도 반영되길 원하시나요?',
  autoNext: true,
  data: [
    { name: '주로 나의 의견이 반영되기를', value: 'OPIN01' },
    { name: '전문가의 추천에 따라 조율하기를', value: 'OPIN02' },
    { name: '전문가가 알아서 제안해주기를', value: 'OPIN03' },
  ],
};

export const COMMUNICATION_STYLE = {
  gtmKey: 'approach',
  title: '전문가와 의견을 나눌 때 어떤 방식이 더 편안하실까요?',
  autoNext: true,
  data: [
    { name: '하나씩 자주 연락하며 진행하는 방식', value: 'COMSTL01' },
    { name: '정리된 내용으로 한 번에 조율하는 방식', value: 'COMSTL02' },
  ],
};

export const BUDGET_OPTION = {
  gtmKey: 'option',
  title: '예산과 상품구성은 어떻게 진행되길 원하시나요?',
  autoNext: true,
  data: [
    { name: '예산을 초과하지 않은 효율적인 구성', value: 'BDGTOPT01' },
    { name: '추천 구성에 따라 소폭 예산 조정', value: 'BDGTOPT02' },
    { name: '예산보다 품질 중심의 제안 우선 고려', value: 'BDGTOPT03' },
  ],
};

// 'site.address': {
//   gtmKey: 'addr',
//   title: '시공할 주소를 입력해 주세요.',
//   autoNext: false,
//   data: null,
// },

export const PERSONAL = {
  gtmKey: 'privacy',
  title: null,
  autoNext: false,
  data: null,
};

// 시퀀셜 상담 신청
export const SEQ_CONSULT_DATA = {
  'site.buildingType': SITE_BUILDING_TYPE,
  'site.houseNMPG': SITE_HOUSE_NMPG,
  'baseConstructionPlan.spaceStatus': SPACE_STATUS,
  'baseConstructionPlan.consultPurpose': CONSULT_PURPOSE,
  'baseConstructionPlan.scopes': SPACE_SCOPES,
  'baseConstructionPlan.budget': BUDGET,
  'baseConstructionPlan.desiredDay': DESIRED_DAY,
  'baseConstructionPlan.consultSchedule': CONSULT_SCHEDULE,
  personal: PERSONAL,
} as const;

// 매칭 상담 신청
export const MATCH_CONSULT_DATA = {
  'baseConstructionPlan.age': AGE,
  'site.buildingType': SITE_BUILDING_TYPE,
  'site.houseNMPG': SITE_HOUSE_NMPG,
  'baseConstructionPlan.spaceStatus': SPACE_STATUS,
  'baseConstructionPlan.consultPurpose': CONSULT_PURPOSE,
  'baseConstructionPlan.consultExperience': CONSULT_EXPERIENCE,
  'baseConstructionPlan.opinionReflect': OPINION_REFLECT,
  'baseConstructionPlan.communicationStyle': COMMUNICATION_STYLE,
  'baseConstructionPlan.scopes': SPACE_SCOPES,
  'baseConstructionPlan.budget': BUDGET,
  'baseConstructionPlan.budgetOption': BUDGET_OPTION,
  'baseConstructionPlan.desiredDay': DESIRED_DAY,
  'baseConstructionPlan.consultSchedule': CONSULT_SCHEDULE,
  personal: PERSONAL,
} as const;

// 상담 유형
export const CONSULT_TYPE_DATA = {
  SEQ: SEQ_CONSULT_DATA,
  MATCH: MATCH_CONSULT_DATA,
} as const;

export const CERTIFY_ERROR_MESSAGE = {
  INACCURATE: '인증번호를 정확히 입력해 주세요.',
  TIME_EXPIRED: '인증시간이 만료 되었습니다. 다시 시도해 주세요.',
  EXCEEDED: '인증번호를 더 이상 전송 할 수 없습니다.',
};
